const SET_FORM_DEFAULT_VALUES = 'redux-form-examples/account/LOAD';

const booksRequestFilter = (state = {}, action) => {
  switch (action.type) {
    case SET_FORM_DEFAULT_VALUES:
      return {
        data: action.data,
      };
    default:
      return state;
  }
}

export const setForm = data => ({ type: SET_FORM_DEFAULT_VALUES, data });

export default booksRequestFilter;
